/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type MarkRequestedFileFulfillment = {
  fulfillment_status: MarkRequestedFileFulfillment.fulfillment_status;
  fulfillment_note?: string | null;
};
export namespace MarkRequestedFileFulfillment {
  export enum fulfillment_status {
    NOT_APPLICABLE = 'not_applicable',
    NOT_AVAILABLE = 'not_available',
    PENDING = 'pending',
  }
}
